import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as apiHelper from "../../../Services/ApiHelper";
import * as toast from "../../../Wrapper/toast/toast";
import MainLoader from "../../_widgets/Loader/MainLoader";
import TemplateDetailsUI from "./TemplateDetailsUI";
const TemplateDetails = () => {
  let { state } = useLocation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [templateData, setTemplateData] = useState({
    name: "",
    category: "",
    language: "",
  });
  const [message, setMessage] = useState("");
  const [footerText, setFooterText] = useState("");
  const [headerText, setHeaderText] = useState("");
  const [headerFormat, setHeaderFormat] = useState("TEXT");
  const [headerMedia, setHeaderMedia] = useState(null);
  const [mediaUploading, setMediaUploading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [variableCount, setVariableCount] = useState(1);
  const [variables, setVariables] = useState([]);
  const [variableValues, setVariableValues] = useState({});
  const [cursorPosition, setCursorPosition] = useState(null);

  const parseHtml = (htmlContent) => {
    let parsedContent = htmlContent;
    Object.keys(variableValues).forEach((key) => {
      const value = variableValues[key] || key;
      parsedContent = parsedContent.replaceAll(key, value);
    });
    return parsedContent;
  };

  useEffect(() => {
    let id = state.id;

    getTemplateDetail(id);
  }, [state]);

  const getTemplateDetail = (id) => {
    setLoading(true);

    apiHelper
      .getTemplateDetail(id)
      .then((response) => {
        if (response?.isSuccess) {
          let data = response.data;
          let components = data.components;
          setTemplateData({
            name: data?.name,
            category: data?.category,
            language: data?.language,
          });
          const headerObj = components.find((item) => item.type === "HEADER");
          setHeaderText(headerObj ? headerObj.text : null);
          setHeaderFormat(headerObj ? headerObj.format : null);

          const bodyObj = components.find((item) => item.type === "BODY");
          setMessage(bodyObj ? bodyObj.text : null);

          const footerObj = components.find((item) => item.type === "FOOTER");
          setFooterText(footerObj ? footerObj.text : null);

          setVariables(data.variables);
          let variableValues = {};

          data.variables.forEach((v, i) => {
            variableValues[v] = data?.var_data?.[i];
          });

          setVariableValues(variableValues);
        } else {
          toast.warn(response?.message);
        }
      })
      .finally(() => setLoading(false));
  };

  const handleMessageChange = (newMessage) => {
    setMessage(newMessage);
    const foundVariables = newMessage.match(/{{[^{}]+}}/g) || [];
    setVariables(foundVariables);
    setVariableValues((prev) => {
      const newValues = {};
      foundVariables.forEach((v) => {
        newValues[v] = prev[v] || "";
      });
      return newValues;
    });
  };

  const copyTemplate = () => {
    navigate("/add-whatsapp-template", {
      state: {
        templateData,
        message,
        footerText,
        headerText,
        headerFormat,
        headerMedia,
        variables,
        variableValues,
      },
    });
  };

  const goBack = useCallback(() => navigate("/template"), []);

  return (
    <>
      {loading ? (
        <MainLoader />
      ) : (
        <TemplateDetailsUI
          templateData={templateData}
          setTemplateData={setTemplateData}
          handleSave={copyTemplate}
          message={message}
          setMessage={setMessage}
          footerText={footerText}
          setFooterText={setFooterText}
          headerText={headerText}
          setHeaderText={setHeaderText}
          headerFormat={headerFormat}
          setHeaderFormat={setHeaderFormat}
          headerMedia={headerMedia}
          setHeaderMedia={setHeaderMedia}
          toolbarOptions={[
            [{ bold: true }, { italic: true }, { underline: true }, { strike: true }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ link: true }],
            ["clean"],
          ]}
          parseHtml={parseHtml}
          buttonLoading={buttonLoading}
          variableCount={variableCount}
          setVariableCount={setVariableCount}
          handleAddVariable={undefined}
          handleVariableChange={undefined}
          variables={variables}
          variableValues={variableValues}
          handleMessageChange={handleMessageChange}
          setCursorPosition={setCursorPosition}
          uploadFiles={undefined}
          navigateBack={goBack}
        />
      )}
    </>
  );
};
export default TemplateDetails;
